import React from "react";
import { motion } from "framer-motion";

const BenefitCard = ({ icon, title, description }) => {
  return (
    <motion.div
      className="card h-100 border-0 glass-panel"
      whileHover={{
        y: -10,
        boxShadow: "0 20px 40px rgba(0, 0, 0, 0.4)",
        borderColor: "var(--primary-accent)"
      }}
      transition={{ duration: 0.3 }}
      style={{
        borderRadius: "4px",
        overflow: "hidden",
        background: "var(--bg-card)",
      }}
    >
      <div className="card-body text-center p-4 d-flex flex-column align-items-center">
        <div
          className="mb-4 d-flex align-items-center justify-content-center"
          style={{
            fontSize: "2.5rem",
            width: "70px",
            height: "70px",
            background: "linear-gradient(135deg, var(--bg-surface), var(--bg-dark))",
            borderRadius: "0",
            color: "var(--highlight-gold)",
            border: "1px solid var(--glass-border)"
          }}
        >
          {icon}
        </div>
        <h3
          className="h5 fw-bold mb-3 text-uppercase"
          style={{
            color: "var(--primary-accent)",
            fontFamily: "var(--font-body)",
            letterSpacing: "2px"
          }}
        >
          {title}
        </h3>
        <p
          className="mb-0"
          style={{
            fontSize: "0.95rem",
            lineHeight: "1.6",
            color: "var(--text-muted)",
            fontWeight: "300"
          }}
        >
          {description}
        </p>
      </div>
    </motion.div>
  );
};

export default BenefitCard;
